import { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  selectDensity,
  selectSidebarStyle,
  selectThemeMode,
} from "state/application/applicationSlice";

export default function RecThemeProvider({ children }) {
  const themeMode = useSelector(selectThemeMode);
  const density = useSelector(selectDensity);
  const sidebarStyle = useSelector(selectSidebarStyle);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", themeMode === "dark" ? "dark" : "light");
    root.setAttribute("data-density", density || "balanced");
    root.setAttribute("data-sidebar", sidebarStyle || "light");
  }, [themeMode, density, sidebarStyle]);

  return children;
}

RecThemeProvider.propTypes = {
  children: PropTypes.node,
};
